import { invalidateQuery } from "@/lib/safe-query/run-safe-query";
import { discountsByRestaurantQueryKey } from "@/query-keys/discounts.keys";
import { menuCatalogQueryKey } from "@/query-keys/menu.keys";
import { logMenuDiag } from "@/utils/menu-load-diagnostics";

let couponsCompletedForKey: string | null = null;
let menuCatalogCompletedForKey: string | null = null;

export function markCouponsFetchCompleted(key: string): void {
  couponsCompletedForKey = key;
}

export function isCouponsFetchCompleted(key: string): boolean {
  return couponsCompletedForKey === key;
}

export function invalidateAvailableCouponsCache(): void {
  couponsCompletedForKey = null;
  invalidateQuery(discountsByRestaurantQueryKey());
}

export function markMenuCatalogFetchCompleted(key: string): void {
  menuCatalogCompletedForKey = key;
  logMenuDiag("menu_catalog_mark_completed", { queryKey: key });
}

export function isMenuCatalogFetchCompleted(key: string): boolean {
  return menuCatalogCompletedForKey === key;
}

export function invalidateMenuCatalogCache(): void {
  logMenuDiag("menu_catalog_cache_invalidated", {
    previousKey: menuCatalogCompletedForKey,
  });
  menuCatalogCompletedForKey = null;
  invalidateQuery(menuCatalogQueryKey());
}
